export default class LocalStorage {

}

LocalStorage.clear = function() {
    localStorage.removeItem("langTestAnswers");
    localStorage.removeItem("langTestStepId");
    localStorage.removeItem("langTestStepNumber");
    localStorage.removeItem("langTestStepsTime");
    localStorage.removeItem("langTestMediaData");
    localStorage.removeItem("langTestPerson");
}

LocalStorage.getPipedrivePerson = function () {
    let person = localStorage.getItem("langTestPerson");
    if (person) {
        return JSON.parse(person)
    }

    return {}
}

/**
 * ANSWERS
 */

LocalStorage.getAnswers = function () {
    let answersList = localStorage.getItem("langTestAnswers");
    if (answersList) {
        return JSON.parse(answersList)
    }

    return {}
}

LocalStorage.setAnswers = function (answersList) {
    localStorage.setItem("langTestAnswers", JSON.stringify(answersList));
}


LocalStorage.addAnswers = function (newAnswersList) {
    let answersList = this.getAnswers()

    for (const [key, value] of Object.entries(newAnswersList)) {
        answersList[key] = value
    }

    LocalStorage.setAnswers(answersList)
}


/**
 * STEP ID
 */

LocalStorage.getStepId = function () {
    let stepId = localStorage.getItem("langTestStepId");
    if (stepId) {
        return parseInt(stepId)
    }

    return 0
}

LocalStorage.setStepId = function (stepId) {
    localStorage.setItem("langTestStepId", stepId);
}


/**
 * STEP NUMBER
 */

LocalStorage.getStepNumber = function () {
    let stepId = localStorage.getItem("langTestStepNumber");
    if (stepId) {
        return parseInt(stepId)
    }

    return 1
}

LocalStorage.setStepNumber = function (stepNumber) {
    localStorage.setItem("langTestStepNumber", stepNumber);
}


/**
 * STEP TIME
 */

LocalStorage.getStepsTime = function () {
    let stepsTime = localStorage.getItem("langTestStepsTime");
    if (stepsTime) {
        return JSON.parse(stepsTime)
    }

    return {}
}

LocalStorage.setStepsTime = function (stepsTime) {
    localStorage.setItem("langTestStepsTime", JSON.stringify(stepsTime));
}

LocalStorage.setStepStartTime = function (stepId) {
    let stepsTime = this.getStepsTime()
    if (!stepsTime['s' + stepId]) {
        stepsTime['s' + stepId] = new Date().toUTCString()
        LocalStorage.setStepsTime(stepsTime)
    }
}

LocalStorage.getStepRemainingTime = function (stepId, stepSeconds) {
    let stepsTime = this.getStepsTime()
    let now = new Date()
    let stepStart;
    if (stepsTime['s' + stepId]) {
        stepStart = new Date(stepsTime['s' + stepId])
    }

    if (stepStart) {
        let diff = (now.getTime() - stepStart.getTime()) / 1000
        if (diff < stepSeconds) {
            return (stepSeconds - diff)
        } else {
            return 0
        }
    } else {
        return stepSeconds
    }
}

/**
 * MEDIA START OFFSET
 */
LocalStorage.setMediaData = function (data) {
    localStorage.setItem("langTestMediaData", JSON.stringify(data));
}

LocalStorage.getMediaData = function () {
    let data = localStorage.getItem("langTestMediaData");
    if (data) {
        return JSON.parse(data)
    }
    return {}
}

LocalStorage.setMediaOffset = function (stepId, videoStartOffset) {
    let data = LocalStorage.getMediaData()
    data['s' + stepId] = videoStartOffset
    LocalStorage.setMediaData(data)
}

LocalStorage.getMediaOffset = function (stepId) {
    let data = LocalStorage.getMediaData()
    if (data && data['s' + stepId]) {
        return parseInt(data['s' + stepId])
    }
    return 0
}
